export default __webpack_public_path__ + "static/david-lopez-edf8d91dc4a6d7b43a78864a87e99996.png";